import { render } from "./FealtyBonus.vue?vue&type=template&id=74c3cd2f"
import script from "./FealtyBonus.vue?vue&type=script&lang=js"
export * from "./FealtyBonus.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/society/windowOverlay/FealtyBonus.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "74c3cd2f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('74c3cd2f', __exports__)) {
    api.reload('74c3cd2f', __exports__)
  }
  
  module.hot.accept("./FealtyBonus.vue?vue&type=template&id=74c3cd2f", () => {
    api.rerender('74c3cd2f', render)
  })

}


export default __exports__